import React from 'react';
import './Verification.css';

function TrustScore({ score }) {
  const maxScore = 100;
  const percentage = Math.min((score / maxScore) * 100, 100);

  const getLevel = () => {
    if (score >= 80) return { label: 'Excellent', color: '#27ae60' };
    if (score >= 50) return { label: 'Bon', color: '#f39c12' };
    if (score >= 20) return { label: 'Basique', color: '#3498db' };
    return { label: 'Nouveau', color: '#95a5a6' };
  };

  const level = getLevel();

  return (
    <div className="trust-score">
      <div className="trust-bar">
        <div
          className="trust-fill"
          style={{ width: `${percentage}%`, background: level.color }}
        />
      </div>
      <span className="trust-label" style={{ color: level.color }}>
        {level.label} ({score})
      </span>
    </div>
  );
}

export default TrustScore;
